<template>
  <div>
    <WsAppBar></WsAppBar>
    <WsNavigationDrawer></WsNavigationDrawer>
    <v-main>
      <router-view></router-view>
    </v-main>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss">
@import "../assets/scss/app.scss";
</style>